import React from "react";

import { about } from "../../editable-stuff/config";
import AboutMe from "./AboutMe";

const AboutSection = () => {
  if (!about.show) {
    return null;
  }

  return (
    <AboutMe
      heading={about.heading}
      message={about.message}
      link={about.imageLink}
      imgSize={about.imageSize}
      resume={about.resume}
    />
  );
};

export default AboutSection;
